import BaseHttp from "@/api/httpHelper";
import apiGwClient from "@/api/api.gateway";
import type { IUserResponse } from "@/types/response";

class UserService extends BaseHttp {
  async login(email: string, password: string, siteToken: string) {
    const { data, error } = await this.post<{ token: string }>(
      "/authenticate",
      {
        email,
        password,
        siteToken,
      },
      { requestKey: "login" }
    );
    return { data, error };
  }
  async forgotPassword(email: string, siteToken: string) {
    const { success, error } = await this.post<boolean>(
      "/forgot-password",
      { email, siteToken },
      { requestKey: "forgotPassword", unsetAuthorization: true }
    );
    return { success, error };
  }
  async resetPassword(email: string, token: string, password: string) {
    const { success, error } = await this.post<boolean>(
      "/reset-password",
      { email, token, password },
      { requestKey: "resetPassword", unsetAuthorization: true }
    );
    return { success, error };
  }
  async getUser() {
    const { data } = await this.get<IUserResponse>(
      "/current",
      {},
      { requestKey: "getUser" }
    );
    return data;
  }
}
export default new UserService(apiGwClient, "/api/v1/users");
